<template lang="pug">
v-container.area-list-item-head.px-0
	v-row(justify="start")
		v-col.shrink.hidden-xs-only(cols="12" md="auto")
			nuxt-link(:to="localePath({name: 'areas-area', params: {area: slug}})")
				v-img(v-if="skimap && skimap.url" :width="$vuetify.breakpoint.smAndUp ? 120: 'auto'" :aspect-ratio="4/3" :src="`${skimap.url}?width=120`" :alt="skimap.alt")
		v-col.grow
			div(style="display: flex;align-items: center;gap: 5px;")
				img.flag.lg(:src="`https://cdn.wintersporters.com/static/images/flags/svg/${country.countryCode}.svg`" :alt="country.name" width="16")
				nuxt-link.font-weight-bold.mb-0.title( :to="localePath({name: 'areas-area', params: {area: slug}})" :title="`Wintersport ${name}`") {{name}}
				v-rating(:value="reviews.average/2" half-increments readonly dense size="18" color="#ffb400" background-color="#ffb400")
				optional-nuxt-link.caption.text-no-wrap.secondary--text( :to="localePath({name: 'areas-area-reviews', params: {area: slug}})") ({{$tc('page.areas._area:reviews.label_{count}', reviews.reviewCount)}})

			factline(v-if="pistes")
				li(icon="valley-run") {{$tc('areas_list_item.pistes_km_{count}', pistes.total, { count: pistes.total })}}
				li
					.graphbar.inline
						div(:style="{width:`${pistes.total/6.5}%`}")
							.piste-green(:style="{width: `${pistes.green_percentage}%`}")
							.piste-blue(:style="{width: `${pistes.blue_percentage}%`}")
							.piste-red(:style="{width: `${pistes.red_percentage}%`}")
							.piste-black(:style="{width: `${pistes.black_percentage}%`}")
			factline
				li(icon="highway" v-if="departures.city  && departures.city.distance != 9999") {{$t('areas_list_item.{distance}_{city}', { distance: departures.city.distance, city:departures.city.node.name })}}
				li(icon="highway" v-if="departures.highway") {{$t('areas_list_item.{distance}_highway', {distance: departures.highway.distance})}}
				li(icon="peak-height" v-if="departures.highway") {{$t('areas_list_item.elevation{min}{max}', {min: minElevation, max: maxElevation})}}
				li(icon="snowflake" v-if="snowheights.nodes.length") {{formatSnowheight(snowheights.nodes[0].snowMountain)}}
			slot
</template>

<style lang="sass">
.graphbar
	display: inline-block
	width: 200px
	height: 8px
	line-height: 8px
	padding: 0
	&>div
		height: 10px
	&>div>div
		display: block
		padding: 0
		margin: 0
		height: 8px
		float: left
	@each $name, $color in $piste-colors
		.piste-#{$name}
			background-color: $color !important

.area-list-item-head
	.v-rating--dense
		margin-top:-2px
	.v-rating--dense .v-icon
		padding: 0
</style>

<script>
export default {
	props: [
		'country',
		'features',
		'id',
		'maxElevation',
		'minElevation',
		'name',
		'pistes',
		'resorts',
		'snowheights',
		'slug',
		'departures',
		'reviews',
		'skimap'
	],
	data() {
		return {
			visibleResortFeatures: []
		};
	},
	methods: {
		formatSnowheight(value) {
			return value == null ? '-' : `${value}cm`;
		},
		setCompareDestination(event) {
			event.target.checked
				? window.addDestinationToCompare(
						this.id,
						this.name,
						this.$cdn(this.skimap_id, 'skimaps', 'w=120')
				  )
				: window.removeDestinationFromCompare(this.id);
		},
		resortFeatures(type) {
			return this.resorts.nodes
				.map(resort => {
					const feature = resort.features.find(f => f.type == type);

					if (
						feature &&
						feature.rating > 1 &&
						this.matchingResortIds.includes(resort.id)
					) {
						resort.text = feature.text;
						resort.rating = feature.rating;
						return resort;
					}
					return false;
				})
				.filter(e => e);
		}
	}
};
</script>
